// Helpers for displaying saved Routes in ML sheet creation.

/**
 * Build a readable label for a route option:
 *   RT1-ATHN-26-27 · Mumbai → Ratnagiri → Goa
 */
export const formatRouteLabel = (route) => {
  if (!route) return '';
  const parts = [
    route.from_location?.location,
    ...((route.via_locations || []).map((v) => v.location)),
    route.to_location?.location,
  ].filter(Boolean);
  const path = parts.join(' → ');
  return route.route_id ? `${route.route_id} · ${path}` : path;
};

/**
 * Ordered unload stops for a route: via hubs + final destination.
 * Falls back to backend-provided `destination_sequence` when present.
 */
export const routeDestinationSequence = (route) => {
  if (!route) return [];
  if (Array.isArray(route.destination_sequence) && route.destination_sequence.length) {
    return route.destination_sequence;
  }
  const via = (route.via_location_ids || []).filter((x) => x != null);
  return route.to_location_hub_id != null ? [...via, route.to_location_hub_id] : via;
};
